<template>
  <mdb-card>
    <mdb-card-body class="p-2">
      <mdb-card-text>
        <div class="bolder">{{subject.name}}</div>
        <div v-if="isBefore" :class="{'red-text': $isToday(subject.testDate)}">
          <div><mdb-icon icon="clock"/> {{$strDate(subject.startDate)}} ~ {{$strDate(subject.endDate)}}</div>
          <mdb-icon icon="clock"/> 평가일: {{$strDate(subject.testDate)}}
          <mdb-btn class="py-1 px-2" v-if="isStudent && $isToday(subject.testDate)" icon="edit">응시</mdb-btn>
          <div>
          필답: {{wScore1}}, 수행: {{pScore}}, 태도: {{aScore}}
          </div>
        </div>
      </mdb-card-text>
    </mdb-card-body>
  </mdb-card>
</template>
<script>
import { mdbIcon, mdbBtn, mdbCard, mdbCardBody, mdbCardTitle, mdbCardText } from 'mdbvue';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'NonNcsSubject',
  components: { mdbIcon, mdbBtn, mdbCard, mdbCardBody, mdbCardText },
  props: ['subject', 'summary'],
  data: () => ({
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapGetters('auth', ['isStudent']),
    isBefore () {
      return this.$strDate(this.subject.testDate) > this.$strDate(new Date())
    },
    wScore1 () {
      return 1;
    },
    wScore2 () {
      return 2;
    },
    pScore () {
      return 3
    },
    aScore () {
      return 3;
    }
  }
}
</script>
